import { Helpers } from '../../helpers';
import { IRecordType } from '../../interfaces/irecord-type';
import { ProjectEstimate } from '../project-estimate';

export class RecordTypeBase {
  RecordTypeId: number;
  Description: string | null;
  SortOrder: number | null;
  Created: Date | null;
  CreatedBy: string | null;
  Updated: Date | null;
  UpdatedBy: string | null;

  ProjectEstimates_RecordType?: Array<ProjectEstimate> | null;

  constructor(item?: IRecordType) {
    if (item) {

      this.RecordTypeId = item.RecordTypeId;
      this.Description = item.Description;
      this.SortOrder = item.SortOrder;
      this.Created = item.Created ? new Date(item.Created) : null;
      this.CreatedBy = item.CreatedBy;
      this.Updated = item.Updated ? new Date(item.Updated) : null;
      this.UpdatedBy = item.UpdatedBy;

      this.ProjectEstimates_RecordType = Helpers.createClassArray(ProjectEstimate, item.ProjectEstimates_RecordType);
    }
  }
}